import * as React from "react"
import Spinner from "../../../hiberUiKit/src/atoms/Spinner/Spinner";

const spinner = require("./../../../../resources/hiber/img/spinner-orange.png");

const Fragment = (React as any).Fragment;

interface Props {
	/**
	 * Indicates if loading should be shown.
	 */
	isLoading: boolean
	/**
	 * Spinner size.
	 */
	spinnerSize?: number
}

/**
 * Loading component.
 * Show content or loading indicator.
 */
export default class Loading extends React.Component<Props, {}> {

	public static defaultProps: Partial<Props> = {
		spinnerSize: 72,
	};

	render() {
		if (this.props.isLoading)
			return <Spinner imgUrl={spinner} size={this.props.spinnerSize}/>;
		else
			return <Fragment>{this.props.children || null}</Fragment>;
	}
}